import { deleteRequest, getRequest, postRequest, putRequest } from 'utilities/http/http';
import userStorage from 'utilities/user/userStorage';
import { reactEnvironmentVariables } from 'utilities/environmentVariables/environmentVariables';
import { FetchHeaders } from 'types';

interface ApiHeaders {
  Authorization: string;
}

type AppendableParameters = string | Record<string, unknown>;

export function apiGetRequest<T>(url: string, appendParameters?: AppendableParameters) {
  const headers = getApiHeaders();
  return getRequest<T>(buildUrl(url, appendParameters), headers);
}

export async function apiPutRequest<T>(
  url: string,
  body?: unknown,
  appendParameters?: string,
) {
  const headers = getApiHeaders();
  return putRequest<T>(buildUrl(url, appendParameters), body, headers);
}

export function apiPostRequest<T>(
  url: string,
  body?: unknown,
  appendParameters?: string,
) {
  const headers = getApiHeaders();
  return postRequest<T>(buildUrl(url, appendParameters), body, headers);
}

export function apiDeleteRequest<T>(url: string, appendParameters?: string) {
  const headers = getApiHeaders();
  return deleteRequest<T>(buildUrl(url, appendParameters), headers);
}

export function buildUrl(url: string, appendParameters?: AppendableParameters) {
  const host = `${reactEnvironmentVariables.API_HOST}/api/`;
  const appId = `application=${reactEnvironmentVariables.APPLICATION_ID}`;
  if (typeof appendParameters === 'string' || typeof appendParameters === 'undefined') {
    appendParameters = appendParameters ? `&${appendParameters}` : '';
  } else {
    // TODO implement this part MATEO
  }
  return `${host}${url}?${appId}${appendParameters}`;
}

export function getApiHeaders(): FetchHeaders & ApiHeaders {
  const Authorization = `Bearer ${userStorage.getToken()}`;
  return {
    Accept: 'application/json',
    Authorization,
  };
}
